import EditTeam from "@/apsales/Teams/Edit";

export default function AddTeam() {
    return <EditTeam mode="add" />;
}